import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { JobReviewTabStatus } from '../constants';
import { RootState } from 'store/reducers';

interface StatusCountState {
  [JobReviewTabStatus.NEEDS_REVIEW]: number;
  [JobReviewTabStatus.IN_PROGRESS]: number;
  [JobReviewTabStatus.CONFIRMED]: number;
  [JobReviewTabStatus.SKIPPED]: number;
  [JobReviewTabStatus.ALL]: number;
}

interface ConfirmJobsState {
  statusCounts: StatusCountState;
  selectedReviewTab: JobReviewTabStatus;
}

const initialState: ConfirmJobsState = {
  statusCounts: {
    [JobReviewTabStatus.NEEDS_REVIEW]: 0,
    [JobReviewTabStatus.IN_PROGRESS]: 0,
    [JobReviewTabStatus.CONFIRMED]: 0,
    [JobReviewTabStatus.SKIPPED]: 0,
    [JobReviewTabStatus.ALL]: 0
  },
  selectedReviewTab: JobReviewTabStatus.NEEDS_REVIEW
};

const confirmJobsSlice = createSlice({
  name: 'confirmJobs',
  initialState,
  reducers: {
    initializeStatusCounts: (
      state,
      action: PayloadAction<{
        needsReviewJobs: number;
        inProgressJobs: number;
        confirmedJobs: number;
        skippedJobs: number;
        totalJobs: number;
      }>
    ) => {
      state.statusCounts = {
        [JobReviewTabStatus.NEEDS_REVIEW]: action.payload.needsReviewJobs,
        [JobReviewTabStatus.IN_PROGRESS]: action.payload.inProgressJobs,
        [JobReviewTabStatus.CONFIRMED]: action.payload.confirmedJobs,
        [JobReviewTabStatus.SKIPPED]: action.payload.skippedJobs,
        [JobReviewTabStatus.ALL]: action.payload.totalJobs
      };
    },
    updateStatusCount: (state, action: PayloadAction<{ status: JobReviewTabStatus; count: number }>) => {
      state.statusCounts[action.payload.status] = action.payload.count;
    },
    setSelectedReviewTab: (state, action: PayloadAction<JobReviewTabStatus>) => {
      state.selectedReviewTab = action.payload;
    }
  }
});

export const { initializeStatusCounts, updateStatusCount, setSelectedReviewTab } = confirmJobsSlice.actions;
export const selectStatusCounts = (state: RootState) => state.rootReducer.confirmJobs.statusCounts;
export const selectSelectedReviewTab = (state: RootState) => state.rootReducer.confirmJobs.selectedReviewTab;

export default confirmJobsSlice.reducer;
